import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import * as userApi from "../../api/userApi/userApi";
import * as managerApi from "../../api/managerApi/managerApi";
import {EQUser, initializeUser} from "../../models/serverModels/EQUser";
import ManagerForm from "./ManagerForm";

const UpdateManager = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: Officer, isLoading: isGetLoading} = useGetQuery<ResponseItem<EQUser>>({
    key: ["OfficerList", {token: tokenState, id: parseInt(id!)}],
    api: () => userApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQUser>,
    Params.Update<EQUser>
  >({
    api: managerApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Manager`);
        queryClient.invalidateQueries("ManagerList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQUser>({defaultValues: initializeUser()});

  const {reset} = methods;

  useEffect(() => {
    reset(Officer?.item);
  }, [Officer?.item, reset]);

  const onSubmit: SubmitHandler<EQUser> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...Officer?.item, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="업체 담당자 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ManagerForm companyDisabled={true} />
            <ConfirmButtonGroup link={`/Manager`} cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateManager;
